import { NavItems } from '@/components/layout/navigation/configNav';
import { create } from 'zustand';

interface AppState {
  navigationPanelOpen: boolean;
  navigationPanelJustClosed: boolean;
  setNavigationPanelOpen: (value: boolean, trackJustClosed?: boolean) => void;
  consoleLayoutConfig: {
    navConfig: {
      title?: string;
      navbar?: NavItems;
      navbarFooter?: React.ReactNode;
    };
  };
  setConsoleLayoutConfig: (config: {
    navConfig: {
      title?: string;
      navbar?: NavItems;
      navbarFooter?: React.ReactNode;
    };
  }) => void;
  resetConsoleLayoutConfig: () => void;
}

const initialState = {
  navigationPanelOpen: false,
  navigationPanelJustClosed: false,
  consoleLayoutConfig: {
    navConfig: {
      title: undefined,
      navbar: undefined,
      navbarFooter: undefined,
    },
  },
};

export const useAppState = create<AppState>((set) => ({
  navigationPanelOpen: false,
  navigationPanelJustClosed: false,
  setNavigationPanelOpen: (value, trackJustClosed) =>
    set((state) => {
      if (value === false) {
        // If closing navigation panel by clicking on icon/button, nav bar should not open again until mouse leaves nav bar
        if (trackJustClosed) {
          return {
            navigationPanelOpen: false,
            navigationPanelJustClosed: true,
          };
        } else {
          // If closing navigation panel by leaving nav bar, nav bar can open again when mouse re-enter
          return {
            navigationPanelOpen: false,
            navigationPanelJustClosed: false,
          };
        }
      } else {
        // If opening nav panel, check if it was just closed by a nav icon/button click
        // If yes, do not open nav panel, otherwise open as per normal
        if (state.navigationPanelJustClosed === false) {
          return {
            navigationPanelOpen: true,
          };
        }
      }
      return {};
    }),
  consoleLayoutConfig: initialState.consoleLayoutConfig,
  setConsoleLayoutConfig: (config) =>
    set({
      consoleLayoutConfig: config,
    }),
  resetConsoleLayoutConfig: () =>
    set({ consoleLayoutConfig: initialState.consoleLayoutConfig }),
}));
